import type { ReactElement } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { ButtonSize } from "components/designV2/buttons/baseButton";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { StampClockLink, StampClockLinkRow } from "./companyStampClock.styled";

export const getStampClockUrl = (): string =>
  `${window.location.origin}${process.env.PUBLIC_URL ?? ""}/company/stampclock`;

export const CopyStampClockLinkButton = (props: {
  readonly size?: ButtonSize;
  readonly url: string;
  readonly variant?: "primary" | "secondary";
}): ReactElement => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const copyLink = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(props.url);
      setIsCopied(true);
    } catch {
      setIsCopied(false);
    }
  };

  const label = t(
    isCopied ? "CompanyStampClock.LinkCopied" : "CompanyStampClock.CopyLink",
  );
  const buttonProps = {
    label,
    size: props.size,
    onClick: () => void copyLink(),
  };

  return props.variant === "primary" ? (
    <PrimaryButton {...buttonProps} />
  ) : (
    <SecondaryButton {...buttonProps} />
  );
};

export const StampClockLinkAccess = (): ReactElement => {
  const stampClockUrl = getStampClockUrl();

  return (
    <StampClockLinkRow>
      <StampClockLink
        href={stampClockUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {stampClockUrl}
      </StampClockLink>
      <CopyStampClockLinkButton url={stampClockUrl} size="small" />
    </StampClockLinkRow>
  );
};
